const PREFIX = "orignal2026.draft.";

export function saveDraft(key, value) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify({ value, savedAt: Date.now() }));
  } catch {
    /* ignore quota */
  }
}

export function loadDraft(key, fallback = "") {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return fallback;
    return JSON.parse(raw).value ?? fallback;
  } catch {
    return fallback;
  }
}

export function clearDraft(key) {
  localStorage.removeItem(PREFIX + key);
}
